import React from 'react';

const PassengerDashboard = () => (
  <div className="fade-in">
    <h1>Passenger Dashboard</h1>
    <p>Top up your wallet or browse trips to start your journey.</p>
  </div>
);
export default PassengerDashboard;